import React from "react";
import styled from "@emotion/styled";
import { Swiper } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

const Container = styled(Swiper)(({ theme }) => ({
  width: "100%",
  maxWidth: "520px",
  height: "100%",
  borderRadius: "10px",
  cursor: "pointer",
}));

const HomeAdSwiper = ({ children }: { children: React.ReactNode }) => {
  return (
    <Container
      modules={[Autoplay, EffectFade]}
      effect={"fade"}
      spaceBetween={50}
      slidesPerView={1}
      autoplay={{ delay: 5000 }}
      fadeEffect={{ crossFade: true }}
      // onSlideChange={() => console.log("slide change")}
      // onSwiper={(swiper: any) => console.log(swiper)}
    >
      {children}
    </Container>
  );
};

export default HomeAdSwiper;
